import { render, staticRenderFns } from "./SubCatalogTree.vue?vue&type=template&id=7bab6e12&scoped=true"
import script from "./SubCatalogTree.vue?vue&type=script&lang=js"
export * from "./SubCatalogTree.vue?vue&type=script&lang=js"
import style0 from "./SubCatalogTree.vue?vue&type=style&index=0&id=7bab6e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bab6e12",
  null
  
)

export default component.exports